

















































import Vue from 'vue'
import Component from 'vue-class-component'
import Icon from '@/components/Icon.vue'
import Auth from '@/components/layout/Auth.vue'
import Card from '@/components/Card.vue'

@Component({
  components: {
    Card,
    Auth,
    Icon
  }
})
export default class BrowserNotSupported extends Vue {
}
